import { ReactNode } from "react";

export interface NotificationSettings {
  emailEnabled: boolean;
  whatsappEnabled: boolean;
  pushNotifyEnabled: boolean;
  marketingEnabled: boolean;
}

export interface NotificationOption {
  icon: ReactNode;
  key: "push" | "whatsapp" | "email" | "marketing";
}

export const notificationOptions: NotificationOption[] = [
  {
    icon: null, // assign icons in component to avoid SSR/react import issues
    key: "push",
  },
  /*,
  {
    label: 'WhatsApp Reminders',
    icon: null,
    key: 'whatsapp',
  },
  {
    label: 'Email Notification',
    icon: null,
    key: 'email',
  },
  {
    label: 'Marketing Messages',
    icon: null,
    key: 'marketing',
  },
  */
];

export const notificationKeyMap = {
  push: "pushNotifyEnabled",
  whatsapp: "whatsappEnabled",
  email: "emailEnabled",
  marketing: "marketingEnabled",
} as const;
